var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLargeFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#576D7E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2344 23.6832C16.2344 23.3532 16.5144 23.0732 16.8644 23.0732C17.1844 23.0732 17.4544 23.3545 17.4544 23.6832V28.6907H20.1731C21.1519 28.6907 21.1731 29.9995 20.1731 29.9995H16.8656C16.5156 29.9995 16.2356 29.7507 16.2356 29.3895V23.6832H16.2344Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9141 23.6829C13.9141 22.8629 15.2341 22.8329 15.2341 23.6829V29.3879C15.2341 30.2179 13.9141 30.2379 13.9141 29.3879V23.6829Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3075 24.3843V25.973H11.8563C12.2163 25.973 12.5763 26.333 12.5763 26.6818C12.5763 27.0118 12.2163 27.2818 11.8563 27.2818H9.3075V29.3805C9.3075 29.7305 9.05875 29.9993 8.70875 29.9993C8.26875 29.9993 8 29.7305 8 29.3805V23.703C8 23.3443 8.27 23.083 8.70875 23.083H12.2175C12.6575 23.083 12.9175 23.3443 12.9175 23.703C12.9175 24.023 12.6575 24.383 12.2175 24.383H9.3075V24.3843Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5341 30.0002C22.1841 30.0002 21.9141 29.7302 21.9141 29.3802V23.704C21.9141 23.344 22.1841 23.084 22.5341 23.084H26.1216C27.0416 23.084 27.0216 24.3827 26.1216 24.3827H23.2441V25.8827H25.7628C26.6516 25.8827 26.6516 27.1927 25.7628 27.1927H23.2441V28.6915H26.2928C27.2028 28.6915 27.2716 30.0002 26.2928 30.0002H22.5341Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeFile);
export default __webpack_public_path__ + "static/media/large_file.b6262dcb4a9cff9e81a9a39170880d51.svg";
export { ForwardRef as ReactComponent };